import { ENDPOINTS } from '../config'
import type { AxiosResponse } from 'axios'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface PostCompleteOnboardingPayload {
  email: string
  name?: string
  workspaceName?: string
  timeZone?: string
  countryCode?: string
  countryName?: string
  workspaceType?: 1 | 2
  inviteToken?: string
  firstTaskNames?: Array<string>
}

export interface PostCompleteOnboardingResponse {
  workspaceId: string
  workspaceSlug: string
  alreadyOnboarded: boolean
}

const postCompleteOnboarding = (
  payload: PostCompleteOnboardingPayload,
): Promise<AxiosResponse<PostCompleteOnboardingResponse>> => {
  return AuthAxios.post(ENDPOINTS.ENDPOINT_POST_COMPLETE_ONBOARDING, payload)
}

export default postCompleteOnboarding
